import allImgPaths from 'assets/images'
import { InputTextField } from 'components/InputField'
import Otp from 'components/Otp'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import objectiveIcon from "./../../assets/images/objective-icon.svg";
import CustomSelect from 'components/common/CustomSelect'
import RfpSocialLinks from 'components/rfp/rfpInnerBox/RfpSocialLinks'

const Onboarding3 = () => {

    const [formData, setFormData] = useState<any>('');

    const handleObjectiveChange = (event: any) => {
        setFormData({
            [event.target.name]: event.target.value,
        });
        if (event.target.name === "objective") {
            let getTextArea = document.getElementById("textAreaRef");
            if (getTextArea) {
                if (event.target.value.length === 0) {
                    event.target.style.height = "24px";
                } else {
                    event.target.style.height = "auto";
                    event.target.style.height = event.target.scrollHeight + "px";
                }
            }
        }
    };

    const handleButtonClick = (event: any) => {
        event?.preventDefault()
        document.getElementById('file-input')?.click();
    }
    return (
        <div className="flex">
            {/* Left banner */}
            <div className="w-2/6">
                <div className="bg-[#1E0AF5] flex flex-col justify-start items-center h-screen">
                    <div className="pt-[77px]">
                        <img className='pb-52 -ml-8' src={allImgPaths.vendorWhiteIcon} alt="" />

                        <div className="pb-10 last:pb-0 relative line-shape done">
                            <h3 className='text-sm font-interSemiBold text-white pb-1 circle-shape'>Basic Details</h3>
                            <ul>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>General Information</li>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>Contact Info</li>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>Social Media Presence</li>
                            </ul>
                        </div>

                        <div className="pb-10 last:pb-0 relative line-shape active">
                            <h3 className='text-sm font-interSemiBold text-white pb-1 circle-shape'>Facility Details</h3>
                            <ul>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>Count & capacity</li>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>Secondary services & features</li>
                            </ul>
                        </div>

                        <div className="pb-10 last:pb-0 relative line-shape">
                            <h3 className='text-sm font-interSemiBold text-white pb-1 circle-shape'>Legal & Compliances</h3>
                            <ul>
                                <li className='text-sm text-[#D2CEFD] pb-1 last:pb-0'>Upload licenses, certification & Insurance</li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>

            {/* Right banner */}
            <div className="w-4/6 flex flex-col">
                <div className="w-full h-screen flex items-center overflow-y-auto">
                    <div className="w-full max-w-[650px] mx-auto">


                        {/* Heading */}
                        <h2 className="font-interSemiBold text-[30px] text-[#101828] pb-8">Basic Details</h2>

                        {/* Form */}
                        <form>
                            <span className='text-sm text-[#667085] inline-block pb-2'>Contact Info</span>

                            <div className="mb-4">
                                <p className="text-[15px] text-[#344054] font-interMedium pb-1">Phone Number</p>
                                <InputTextField
                                    label={""}
                                    name={"name"}
                                    placeholder={"Enter Here"}
                                    onChange={() => { }}
                                    value={''}
                                    type="number"
                                />
                            </div>

                            <div className="mb-12">
                                <p className="text-[15px] text-[#344054] font-interMedium pb-1">Email Address</p>
                                <InputTextField
                                    label={""}
                                    name={"name"}
                                    placeholder={"Enter Here"}
                                    onChange={() => { }}
                                    value={''}
                                    type="email"
                                />
                            </div>

                            <span className='text-sm text-[#667085] inline-block pb-2'>Business Address</span>
                            <div className="mb-4">
                                <p className="text-[15px] text-[#344054] font-interMedium pb-1">Street Address</p>
                                <InputTextField
                                    label={""}
                                    name={"name"}
                                    placeholder={"Enter Here"}
                                    onChange={() => { }}
                                    value={''}
                                    type="text"
                                />
                            </div>

                            <div className="w-full">
                                <div className="flex gap-x-4 w-full mb-4">
                                    <div className="w-1/2">
                                        <p className="text-[15px] text-[#344054] font-interMedium pb-1">City</p>
                                        <InputTextField
                                            label={""}
                                            name={"name"}
                                            placeholder={"Enter Here"}
                                            onChange={() => { }}
                                            value={''}
                                            type="text"
                                        />
                                    </div>
                                    <div className="w-1/2">
                                        <p className="text-[15px] text-[#344054] font-interMedium pb-1">State/Province</p>
                                        <InputTextField
                                            label={""}
                                            name={"name"}
                                            placeholder={"Enter Here"}
                                            onChange={() => { }}
                                            value={''}
                                            type="text"
                                        />
                                    </div>
                                </div>

                                <div className="flex gap-x-4">
                                    <div className="w-1/2">
                                        <p className="text-[15px] text-[#344054] font-interMedium pb-1">Postal Code</p>
                                        <InputTextField
                                            label={""}
                                            name={"name"}
                                            placeholder={"Enter Here"}
                                            onChange={() => { }}
                                            value={''}
                                            type="number"
                                        />
                                    </div>
                                    <div className="w-1/2">
                                        <p className="text-[15px] text-[#344054] font-interMedium pb-2.5">Country</p>
                                        <div className="modal-select-box fete-settings-modals">
                                            <CustomSelect
                                                options={
                                                    [
                                                        { label: "value 1", value: "value 1" },
                                                        { label: "value 2", value: "value 2" }
                                                    ]
                                                }
                                                onChange={() => { }}
                                                extendedOption={false}
                                            />
                                            {/* <p className='text-[#D92D20] text-sm pt-0.5'>error</p> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <div className="flex gap-x-3 justify-end mt-10">
                            <button className="rounded-md border border-[#1E0AF5] text-[#1E0AF5] hover:bg-[#E8E6FE] flex gap-x-1.5 items-center !pl-2 !pr-4 font-interSemiBold" type="submit">
                                <img className='w-[22px] h-[22px]' src={allImgPaths.vendorLeftArrowBlueIcon} alt="" />
                                Prev
                            </button>
                            <button className="submit-btn-blue blue-btn-hover flex gap-x-1.5 items-center !pl-4 !pr-2" type="submit">
                                Next
                                <img className='w-[22px] h-[22px]' src={allImgPaths.vendorLeftArrowIcon} alt="" />
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Onboarding3